module.exports = __webpack_public_path__ + "static/EnsinoHibrido-fd3ddeac8fe6dc1fae8c6990d374d074.svg";